import * as React from "react";

import { DesignToken } from "@livechat/design-system-react-components";

import { Icon, IconsEnum } from "components/icon";
import { trackAgentProfileClicked } from "helpers/analytics-reports";
import { IRanking } from "store/views/reports";
import { withVar } from "themes/helpers";

import { tableGrid } from "../styled/table-grid";
import { ratedCount } from "../styled/table-rate-cell";
import { agentCell, header, otherCell, ratedTicketsCell, row } from "../styled/top-rated-agents-table-grid";
import { textMuted, textPrimary, textSmall } from "../styled/typography";

import { AgentCard } from "./AgentCard";

const headCellText = [textSmall, textMuted];

interface IProps {
  ranking: IRanking[];
  type: string;
}

export const TopRatedAgentsTable: React.FC<IProps> = props => (
  <div css={tableGrid}>
    <div css={header}>
      <div css={[agentCell, headCellText]}>Agents</div>
      <div css={[ratedTicketsCell, headCellText]}>Rated tickets</div>
      <div css={[otherCell, headCellText]}>Rated great</div>
      <div css={[otherCell, headCellText]}>Rated okay</div>
      <div css={[otherCell, headCellText]}>Rated bad</div>
    </div>
    {props.ranking.map(v => (
      <div css={row} key={v.id}>
        <div css={agentCell}>
          <AgentCard
            avatarUrl={v.photoUrl}
            name={v.name}
            email={v.email}
            removed={v.removed}
            onClick={() => trackAgentProfileClicked(props.type)}
          />
        </div>
        <div css={ratedTicketsCell}>
          <span css={textPrimary}>{v.total}</span>
        </div>
        <div css={otherCell}>
          <Icon
            name={IconsEnum.SmileyHappy}
            width="15px"
            height="15px"
            fill={withVar(DesignToken.ActionPositiveDefault)}
            inline
          />
          <span css={ratedCount}>{v.ratedGreatCount}</span>
          <span css={textMuted}>({v.ratedGreatPercentage}%)</span>
        </div>
        <div css={otherCell}>
          <Icon
            name={IconsEnum.SmileyOkay}
            width="15px"
            height="15px"
            fill={withVar(DesignToken.ActionPositiveDefault)}
            inline
          />
          <span css={ratedCount}>{v.ratedOkayCount}</span>
          <span css={textMuted}>({v.ratedOkayPercentage}%)</span>
        </div>
        <div css={otherCell}>
          <Icon
            name={IconsEnum.SmileySad}
            width="15px"
            height="15px"
            fill={withVar(DesignToken.ActionNegativeDefault)}
            inline
          />
          <span css={ratedCount}>{v.ratedBadCount}</span>
          <span css={textMuted}>({v.ratedBadPercentage}%)</span>
        </div>
      </div>
    ))}
  </div>
);
